/*
 * Second-Level-Navigation und Breadcrumb
 */
/**
 * @namespace NavigationSwiper
 */
SWRNEU.NavigationSwiper = function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'navigationswiper';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '.breadcrumb,#header'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var NavigationSwiper = function () {
    function NavigationSwiper(element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);

      if(self.$element.is('#header')) {
        const $secondLevelNavi = self.$element.find('.navbar-second-level-navi > ul');

        if($secondLevelNavi.length > 0) {
          self.element = $secondLevelNavi[0];
          self.$element = $(self.element);

          self.init();
        }
      } else {
        self.init();
      }

      //Da die Second-Level-Navi nur initialisiert werden soll,
      //wenn sich das HTML geändert hat und nicht bei jeder
      //PJAX-Navigation, wird aus dem PJAX-JS heraus dieses
      //Event getriggert.
      $(document).on('swr:navigationswiper:init', function () {
        self.element = $('.navbar-second-level-navi > ul');
        self.$element = $(self.element);
        self.init();
      });
    }

    NavigationSwiper.prototype.init = function init() {
      var self = this;
      self.parent = self.$element.parent()[0];
      self.$parent = $(self.parent);
      self.config = {};
      self.isBreadcrumb = self.$element.hasClass('breadcrumb');

      if (self.isBreadcrumb) {
        self.parent = self.$element.closest('.breadcrumbs')[0];
        self.$parent = $(self.parent);
      }

      if (!self.$element.parent().is('nav')) {
        self.$element.wrap('<div class="nav-wrapper"><nav /></div>');
      }
      self.element = self.$element.parent()[0];
      self.$element = self.$element.parent();

      // render
      self.$element.addClass('navswiper');
      self.$element.attr('aria-label', 'Zusatznavigation');

      if (self.isBreadcrumb) {
        self.$parent.append(self.$element);
        self.$parent.find('.row').remove();
      }

      var $naviList = self.$element.children('ul, ol');
      $naviList.addClass('navswiper-wrapper');
      $naviList.children('li').addClass('navswiper-slide');

      self.$element.append($(
        '<div class="swiper-button-prev">' +
        '  <button type="button" class="btn btn-tertiary btn-icon" aria-label="Subnavigation zurück blättern">' +
        '  ' + SWRNEU.Util.svgIcon('prev') +
        '  </button>' +
        '</div>' +
        '<div class="swiper-button-next">' +
        '  <button type="button" class="btn btn-tertiary btn-icon" aria-label="Subnavigation weiter blättern">' +
        '  ' + SWRNEU.Util.svgIcon('prev') +
        '  </button>' +
        '</div>'));

      self.swiper = new Swiper(self.element, {
        freeMode: true,
        slidesPerView: 'auto',
        containerModifierClass: 'navswiper-',
        slideClass: 'navswiper-slide',
        slideActiveClass: 'navswiper-slide-active',
        slideVisibleClass: 'navswiper-slide-visible',
        slideNextClass: 'navswiper-slide-next',
        slidePrevClass: 'navswiper-slide-prev',
        wrapperClass: 'navswiper-wrapper',
        focusableElements: 'input, select, option, textarea, video, label, a',
        preventClicks: false,
        watchSlidesProgress: true,
        navigation: {
          nextEl: '.swiper-button-next button',
          prevEl: '.swiper-button-prev button',
        },
        a11y: {
          enabled: false
        },
        on: {
          init: function (swiperInstance) {
            console.log("init", swiperInstance);
            //Wenn das Ende des Swipers nicht erreicht ist,
            //wird das Ende durch den Verlauf verdeckt.
            toggleFadeOutRight(!swiperInstance.isEnd);
          },
          navigationNext: function navigationNext(swiperInstance) {
            console.log("navigationNext", swiperInstance);
            sliderMoved(swiperInstance);
          },
          navigationPrev: function navigationPrev(swiperInstance) {
            console.log("navigationPrev", swiperInstance);
            sliderMoved(swiperInstance);
          },
          sliderMove: function sliderMove(swiperInstance, event) {
            console.log("sliderMove", swiperInstance.activeIndex);
            sliderMoved(swiperInstance);
          },
          resize: function resize(swiperInstance) {
            console.log("resize", swiperInstance);
            if (swiperInstance.isLocked) {
              toggleFadeOutLeft(false);
              toggleFadeOutRight(false);
            } else {
              sliderMoved(swiperInstance);
            }
          },
          click: function click(swiperInstance, event) {
            //Bei jedem Klick wird geprüft, ob der geklickte Slide angeschnitten ist.
            //Wenn ja, dann wird der Swiper so verschoben, dass der Slide
            //komplett sichtbar ist, inkl. eventueller Sublist.
            console.log("click", swiperInstance, event);
            const currentSwiperTranslate = swiperInstance.translate;

            const clickedSlide = swiperInstance.clickedSlide;

            // Hier aufhören, wenn zwischen zwei Elementen auf den Swiper geklickt wurde
            if (!clickedSlide) {
              // Dem Header Bescheid sagen, dass auf ihn geklickt wurde (Event wird von SwiperJS am bubblen gehindert)
              $(document).trigger("click.swr.header.data-api");
              return;
            }

            const containerRect = swiperInstance.el.getBoundingClientRect();
            const slideRect = clickedSlide.getBoundingClientRect();
            const dropdownList = clickedSlide.lastElementChild;
            const dropdownRect = dropdownList && dropdownList.getBoundingClientRect
              ? dropdownList.getBoundingClientRect()
              : null;
            const tolerance = 1;

            const targetRect = (() => {
              if (!dropdownRect || !clickedSlide.classList.contains('navbar-expandable')) {
                return slideRect;
              }

              return {
                left: Math.min(slideRect.left, dropdownRect.left),
                right: Math.max(slideRect.right, dropdownRect.right)
              };
            })();

            const leftOverflow = Math.max(0, containerRect.left - targetRect.left);
            const rightOverflow = Math.max(0, targetRect.right - containerRect.right);

            if (leftOverflow > tolerance) {
              //Geklickter Slide ist links angeschnitten
              swiperInstance.translateTo(currentSwiperTranslate + leftOverflow, 500, true, true);
              self.sliderMovedOutOfBounds = false;

              return;
            }

            if (rightOverflow > tolerance) {
              //Geklickter Slide ist rechts angeschnitten
              self.sliderMovedOutOfBounds = false;
              swiperInstance.translateTo(currentSwiperTranslate - rightOverflow, 500, true, true);

              return;
            }

            if (self.sliderMovedOutOfBounds) {
              swiperInstance.translateTo(currentSwiperTranslate, 500, true, true);
            }
          }
        }
      });

      function sliderMoved(swiperInstance){
        //Wenn wir uns nicht am Anfang des Swipers befinden
        //oder der aktive Slide nicht der erste Slide ist,
        //wird der Anfang durch den Verlauf verdeckt.
        toggleFadeOutLeft(!swiperInstance.isBeginning || swiperInstance.activeIndex !== 0);

        //Wenn wir uns nicht am Ende des Swipers befinden,
        //wird das Ende durch den Verlauf verdeckt.
        toggleFadeOutRight(!swiperInstance.isEnd);
      }

      function toggleFadeOutLeft(add) {
        //Verlauf vorne:
        if (add) {
          self.$parent.addClass('fade-out-left');
        } else {
          self.$parent.removeClass('fade-out-left');
        }
      }

      function toggleFadeOutRight(add) {
        //Verlauf hinten:
        if (add) {
          self.$parent.addClass('fade-out-right');
        } else {
          self.$parent.removeClass('fade-out-right');
        }
      }
    };

    NavigationSwiper.prototype._destroy = function _destroy() {
      var self = this;
      console.log("DESTROY");
      self.swiper.destroy();

      //Der Wrapper wird entpackt und entfernt:
      self.element = self.$element.find('.navswiper-wrapper')[0];
      self.$element = $(self.element);
      self.$element.unwrap();
      $('.navswiper').remove();
      //Die Buttons werden entfernt:
      self.$element.find('.swiper-button-prev, .swiper-button-next').remove();
    };

    // public
    NavigationSwiper.prototype.dispose = function dispose() {
      this._destroy();

      this.$element.off(EVENT_KEY);

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    NavigationSwiper._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new NavigationSwiper(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return NavigationSwiper;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    NavigationSwiper._jQueryInterface.call($element);
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    //Dieser Event-Listener gilt nur für die Breadcrumbs
    //Die Second-Level-Navigation wird per Event (s.o.) initialisiert
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      NavigationSwiper._jQueryInterface.call($element);
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = NavigationSwiper._jQueryInterface;
  $.fn[NAME].Constructor = NavigationSwiper;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return NavigationSwiper._jQueryInterface;
  };

  return NavigationSwiper;

}(window.jQuery);
